/** Copyright (c) 2017 T. Rowe Price. All rights reserved. */

import React from 'react';
import { connect } from 'react-redux';

import BaseModal from '../Modal/BaseModal';
import Disclosure from 'components/shared/Disclosure/Disclosure';
import { getAsOfDate } from 'state/account/AccountSelectors';
import { FormattedDate } from 'components/shared/Text/Text';
import Content from 'services/Content';

const AsOfDateModal = ({
  label = 'As of',
  asOfDate,
  containerClassName,
  isDesktopLayout,
  is529Only,
  ...props
}) =>
  isDesktopLayout ? (
    <span
      className={`as-of-modal ${containerClassName}`}
      data-testid={'as-of-modal-disclosure-container'}>
      {label}&nbsp;<FormattedDate>{asOfDate}</FormattedDate> unless otherwise
      indicated &nbsp;
      <BaseModal
        containerClassName="modal-info-container modal-disclosure-container"
        title="Important Information Regarding the Updating of Account Balances"
        linkContent=""
        label={label}
        {...props}>
        <Disclosure
          content={
            is529Only
              ? Content.asOfDateDisclosure529Only
              : Content.asOfDateDisclosure
          }
        />
      </BaseModal>
    </span>
  ) : (
    <div className={`responsive-${containerClassName}`}>
      {label}&nbsp;<FormattedDate>{asOfDate}</FormattedDate>
    </div>
  );

const mapStateToProps = (state) => ({
  isDesktopLayout: state.view.isDesktopLayout,
  asOfDate: getAsOfDate(state),
  is529Only: state.view.hasCollegeSavingsOnly
});

export default connect(mapStateToProps)(AsOfDateModal);
